import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React from 'react';
import { useReaconditionedContainer } from '../hooks/useReaconditionedContainer';
import { ReaconditionedContainerStyle } from './style';

const ReaconditionedContainer = ({ appCtx, productAttributes }) => {
  const hookData = useReaconditionedContainer({ appCtx, productAttributes });

  const { condition, messageText, showLink, reaconditionedLink, shouldRender } = hookData;

  if (!shouldRender) {
    return null;
  }

  const blockClass = 'reaconditioned';
  const containerClasses = cx(blockClass);

  return (
    <div className={containerClasses} data-testid="reaconditioned">
      <div className={`${blockClass}__icon-container`}>
        <span className={`${blockClass}__icon`} />
      </div>
      <div className={`${blockClass}__content`}>
        <div className={`${blockClass}__text`}>
          <span className={`${blockClass}__description`}>
            {messageText}
            <span className={`${blockClass}__description--highlight`}>{condition.name}</span>.
          </span>
          {showLink && (
            <a
              target="_blank"
              href={reaconditionedLink}
              rel="noopener noreferrer"
              className={`${blockClass}__link`}
              aria-label="Conocer más sobre productos reacondicionados"
            >
              Conocer más
            </a>
          )}
        </div>
      </div>
      <style jsx>{ReaconditionedContainerStyle}</style>
    </div>
  );
};

ReaconditionedContainer.propTypes = {
  appCtx: PropTypes.object.isRequired,
  productAttributes: PropTypes.object.isRequired,
};

export default ReaconditionedContainer;
export { ReaconditionedContainer };
